import { createContext, useContext } from 'react'

export interface ShadowDomContextProps {
  root: ShadowRoot | null
  portalContainer: HTMLElement | null // Default container (most components)
  containerPortalContainer: HTMLElement | null // Container queries enabled
}

export const ShadowDomContext = createContext<ShadowDomContextProps>({
  root: null,
  portalContainer: null,
  containerPortalContainer: null,
})

export const useShadowDomContext = (): ShadowDomContextProps => useContext(ShadowDomContext)
